import { injectable } from 'inversify';
import { INotificationMutationReadService } from './notification-mutation-read.interface';

@injectable()
export class NotificationMutationReadMock implements INotificationMutationReadService {
    read(): void {
        throw new Error('Method not implemented.');
    }
}
